export default class BasePageableInfo<T> {
  count: number = 0
  dataList: T[] = []
}
